export const SAVE_SETTINGS = 'SAVE_SETTINGS'
export const GOOGLE_APIS_LOADED = 'GOOGLE_APIS_LOADED'
export const AZURE_MAPS_API_LOADED = 'AZURE_MAPS_API_LOADED'
